export default {
  // namespaced: true,
  state: {
    new_billing: {
      new: null,
      plan: null,
      customer: null,
      paymant: null,
      subscription: null
    }
  },
  mutations: {
    SET_BILLING_NEW (store, data) {
      store.new_billing.new = data
    },
    SET_BILLING_PLAN (store, data) {
      store.new_billing.plan = data
    },
    SET_BILLING_CUSTOMER (store, data) {
      store.new_billing.customer = data
    },
    SET_BILLING_PAYMENT (store, data) {
      store.new_billing.paymant = data
    },
    SET_BILLING_SUBSCRIPTION (store, data) {
      store.new_billing.subscription = data
    }
  },
  getters: {
    getBillingNew: (store, getters) => {
      return store.new_billing.new
    },
    getBillingPlan: (store, getters) => {
      return store.new_billing.plan
    },
    getBillingCustomer: (store, getters) => {
      return store.new_billing.customer
    },
    getBillingPayment: (store, getters) => {
      return store.new_billing.payment
    },
    getBillingSubscription: (store, getters) => {
      return store.new_billing.subscription
    }
  },
  actions: {
    setBillingNew ({commit, dispatch, getters, state}, data) {
      commit('SET_BILLING_NEW', data)
    },
    setBillingPlan ({commit, dispatch, getters, state}, data) {
      commit('SET_BILLING_PLAN', data)
    },
    setBillingCustomer ({commit, dispatch, getters, state}, data) {
      commit('SET_BILLING_CUSTOMER', data)
    },
    setBillingPayment ({commit, dispatch, getters, state}, data) {
      commit('SET_BILLING_PAYMENT', data)
    },
    setBillingSubscription ({commit, dispatch, getters, state}, data) {
      commit('SET_BILLING_SUBSCRIPTION', data)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/CreateBilling.js